import * as THREE from "three";
import { useEffect, useState } from "react";
import { Html } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { ILocation } from "../models/general.model";
import { Typography } from "@mui/material";
import { IHotspot } from "../models/hotspot.model";
import { useControls } from "leva";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import info from "../components/assets/info.svg";
import { InfoModel } from "./InfoModel";
import Paper from "@mui/material/Paper/Paper";
import AppPrimaryButton from "../appComponents/buttons/AppPrimaryButton";
import CloseRounded from "@mui/icons-material/CloseRounded";
import IconButton from "@mui/material/IconButton";
import InformationModal from "../components/layouts/InformationModal";
import { InfoOutlineModel } from "./InfoOutlineModel";
import ReactGA from "react-ga4";

type GLTFResult = GLTF & {
  nodes: {
    Circle: THREE.Mesh;
    Circle001: THREE.Mesh;
  };
  materials: {
    ["Material.001"]: THREE.MeshStandardMaterial;
  };
};

interface IProps {
  hotspot: IHotspot;
  clicked: string;
  setClicked: any;
  clickedOpen: any;
}

export function Information({
  hotspot,
  clicked,
  setClicked,
  clickedOpen,
}: IProps) {
  // const controller = useControls({
  //   [`${hotspot.id}-x`]: { value: hotspot.position.x, min: -100, max: 100 },
  //   [`${hotspot.id}-y`]: { value: hotspot.position.y, min: -100, max: 100 },
  //   [`${hotspot.id}-z`]: { value: hotspot.position.z, min: -100, max: 100 },

  //   [`${hotspot.id}-scale`]: { value: hotspot.scale, min: -100, max: 100 },

  //   // [`${hotspot.id}-r-x`]: {
  //   //   value: hotspot.rotation.x,
  //   //   min: -360,
  //   //   max: 360,
  //   // },
  //   // [`${hotspot.id}-r-y`]: {
  //   //   value: hotspot.rotation.y,
  //   //   min: -360,
  //   //   max: 360,
  //   // },
  //   // [`${hotspot.id}-r-z`]: {
  //   //   value: hotspot.rotation.z,
  //   //   min: -360,
  //   //   max: 360,
  //   // },
  // });

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      {clicked === hotspot.id && (
        <mesh
          position={[
            // controller[`${hotspot.id}-x`],
            // controller[`${hotspot.id}-y`] + 20,
            // controller[`${hotspot.id}-z`],
            hotspot.position.x,
            hotspot.position.y,
            hotspot.position.z,
          ]}
        >
          <Html>
            <Paper
              sx={{
                heigh: "100%",
                width: "100%",
                minWidth: "200px",
                maxWidth: "900px",
                padding: "22px 10px 0px 10px",
                pointer: "default",
              }}
              // onPointerOver={() => setHover(true)}
              // onPointerOut={() => setHover(false)}
            >
              <IconButton
                style={{
                  position: "absolute",
                  top: -15,
                  right: -15,
                  backgroundColor: "#fff",
                }}
                onClick={() => setClicked("")}
              >
                <CloseRounded />
              </IconButton>
              <Typography
                variant={"h6"}
                sx={{ fontSize: "1em" }}
                align="center"
              >
                Modern Furniture VOCs
              </Typography>
              <Typography
                variant={"subtitle1"}
                sx={{ fontSize: "0.8em" }}
                align="center"
              >
                Is your sofa making you sick?
              </Typography>
              <AppPrimaryButton
                size="small"
                onClick={() => {
                  setClicked("");
                  clickedOpen(hotspot);
                }}
              >
                Learn More
              </AppPrimaryButton>
            </Paper>
          </Html>
        </mesh>
      )}
      {clicked !== hotspot.id && (
        <InfoOutlineModel
          // hover={hover}
          // setHover={hovered}
          onClick={() => {
            clickedOpen(hotspot);
            ReactGA.event({
              category: "info-hotspot-clicked",
              action: JSON.stringify(hotspot),
            });
          }}
          position={[
            // controller[`${hotspot.id}-x`],
            // controller[`${hotspot.id}-y`],
            // controller[`${hotspot.id}-z`],
            hotspot.position.x,
            hotspot.position.y,
            hotspot.position.z,
          ]}
          scale={hotspot.scale}
          setModalOpen={setModalOpen}
        />
      )}
    </>
  );
}
